import React from "react";

const Auth0EmailVerificationPending = ({ onUseOtherAccount }) => (
  <div className=" mt-50">
    <div className="ui middle aligned center aligned grid">
      <div className="ui center aligned yellow very padded segment">
        <div className="column">
          <div className="content">
            <div className="ui">
              <img alt="" className="ui centered medium rounded bordered image" style={{ maxWidth: "120px" }} src="../images/logo_250.png" />
            </div>

            <h1>Só falta mais um passo!</h1>
            <h3>Agora é necessário confirmares o e-mail que te acabamos de enviar.</h3>
            <p>
              Necessitas de ajuda?{" "}
              <a target="_blank" rel="noreferrer" href="https://salespark.io/redirect/?u=confirmacao-de-endereco-de-e-mail">
                Clica aqui
              </a>
            </p>
            <br />
            <button type="button" onClick={onUseOtherAccount} className="ui button mini basic blue">
              Iniciar sessão com outros dados.
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default Auth0EmailVerificationPending;
